import React from 'react';
import ReactDOM from 'react-dom/client';
import { GoogleOAuthProvider } from '@react-oauth/google'; // Import Google Provider
import App from './App';
import './styles.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import { AuthProvider } from './contexts/AuthContext'; // Import AuthProvider
import { WebSocketProvider } from './contexts/WebSocketContext'; // Keep WebSocketProvider
import { ServerConnectionProvider } from './contexts/ServerConnectionContext';
import { NotificationProvider } from './contexts/NotificationContext';

// Ensure you replace this with your actual Google Client ID
const googleClientId = "211990271011-70jalrvltb2vr7sp0mc168g3spc44qv0.apps.googleusercontent.com";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <GoogleOAuthProvider clientId={googleClientId}>
      <AuthProvider> {/* AuthProvider wraps WebSocketProvider */}
         <WebSocketProvider> {/* WebSocketProvider inside AuthProvider */}
          <NotificationProvider>
            <ServerConnectionProvider>
             <App />
            </ServerConnectionProvider>
          </NotificationProvider>
         </WebSocketProvider>
      </AuthProvider>
    </GoogleOAuthProvider>
  </React.StrictMode>
);